/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  message,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import Moment from 'moment';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import {
  deleteJornadadetalleHorario,
} from 'api/catalogos/JornadaDetalleHorario';
import API from 'utils/api';
import { checkToken } from 'api/utils';
import { deleteJornadaModificacionDetalle, getJornadasModificacionDetalle } from 'api/catalogos/JornadaModificacionDetalle';

export const modificaciondejornadamodificacionPermission = {
  permissionModel: 'modificaciondejornadamodificacion',
  hasAllViewPermissions: true,
};

const JornadasModificacionDetalle = ({
  permission,
  JornadaModificacion,
  disableDelete,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [empleadoNombreBorrar, setEmpleadoNombreBorrar] = useState('');

  const formInstances = [
    form,
    formDatos,
  ];

  const baseURI = '/catalogos/modificacion-de-jornada-modificacion/';

  const fetchData = async (page = 1, q = {}) => {
    setLoading(true);
    const response = await API.get(baseURI, {
      params: {
        modificacion_de_jornada: JornadaModificacion,
        page,
        ...q,
      },
    });
    const { results } = response.data;
    setData({ ...response.data, results });
    setLoading(false);
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos

      const response = await API.get(baseURI, {
        params: {
          page: cleanPage,
          modificacion_de_jornada: JornadaModificacion, //  filtro del padre
          ...q,
        },
      });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([

        getJornadasModificacionDetalle({ modificacion_de_jornada: JornadaModificacion }),
      ]);
      const { results } = _data;
      if (mounted) {
        setData({ ..._data, results });
        setLoading(false);
      }
    };
    if (JornadaModificacion) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [JornadaModificacion]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formDatos.resetFields();
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteJornadaModificacionDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const columns = [
    {
      titleText: 'Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 250,
    },
    {
      titleText: 'Número de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 150,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 250,
    },
    {
      titleText: 'Jornada',
      dataIndex: 'jornada_descripcion',
      key: 'jornada_descripcion',
      width: 150,
    },
    {
      titleText: 'Horario',
      dataIndex: 'jornada_detalle_rango',
      key: 'jornada_detalle_rango',
      width: 300,
    },
  ];
  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    const empleadoSeleccionado = data?.results?.find((item) => item.id === key);

    if (empleadoSeleccionado) {
      setEmpleadoNombreBorrar(empleadoSeleccionado.empleado?.numero_y_nombre_completo || '');
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={(data?.results || []).map((item) => ({
            ...item,
            numero_y_nombre_completo: item.empleado?.numero_y_nombre_completo,
            numero_de_empleado: item.empleado?.numero_de_empleado,
            tipo_empleado_descripcion: item.empleado?.tipo_empleado_descripcion,
            tipo_de_nomina_empleado_descripcion: item.empleado?.tipo_de_nomina_empleado_descripcion,
            puesto_clave_y_descripcion: item.empleado?.puesto_clave_y_descripcion,
            directorio_de_area_clave_y_nombre: item.empleado?.directorio_de_area_clave_y_nombre,
            jornada_descripcion: item.modificacion_de_jornada?.jornada?.descripcion,
            jornada_detalle_rango: item.modificacion_de_jornada?.jornada_detalle?.descripcion_rango_horario,
          }))}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          cols={columns}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickDelete,
          }}
          disableDelete={disableDelete}
          permission={{
            hasAllViewPermission: true,
            delete: true,
          }}
          allowExportPDF={false}
        />
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={` al empleado ${empleadoNombreBorrar}?`}
          loading={loading}
        />

      </Spin>
    </Row>
  );
};

export default JornadasModificacionDetalle;
